import React from 'react';
import { FunctionComponent } from 'react';
import { taskSimpleSelectors } from '../../../../../../../app/resource/task-simple/task-simple.selectors';
import { useSelectWithParams } from '../../../../../../../utils/selector.utils';
import { CopyTask } from './CopyTask';
import { DeleteTask } from './DeleteTask';
import { MoveTask } from './MoveTask';
import { ShareTask } from './ShareTask';
import { ITaskActionsProps } from './types';
// import { WatchTask } from './WatchTask';

export const TaskActions: FunctionComponent<ITaskActionsProps> = ({ taskId }) => {
  const task = useSelectWithParams(taskSimpleSelectors.selectResourceById, taskId ?? '');

  return (
    <>
      <h5 className="bold mt-4">ACTIONS</h5>
      <div className="buttons">
        {task && <ShareTask task={task} />}
        {task && <MoveTask task={task} />}
        {/* {task && <CopyTask task={task} />} */}
        {/* {task && <WatchTask taskId={taskId} />} */}

        {/*
        <a className="btn w100 gray-bg darkGray px-1 f-1 ml-0 mb-1 mt-1 check_button">
          <img src={require('../../../../../../../../resources/images/labels-icon.png')} className="mr-1" alt="img" />{' '}
          Archive
        </a> */}
        {task && <DeleteTask task={task} />}
      </div>
    </>
  );
};
